export { AtnDsPageHeaderPaginationComponent as Component } from './page-header-pagination.component'
